
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IconRegistry } from '../lib/IconRegistry';
import Branch from "../lib/Branch";
import Atlanta from "../insurerLandingPages/Atlanta.vue";
import { api } from "../Api";

@Component(
    {
        components: { Atlanta },
    },
)
export default class Default extends Vue {
    public rgs = [];

    deleteCookie(id) {
        api.deleteCookie('rg_' + id);
        let match = null;
        this.$store.state.responseGroupCookies.forEach((rg) => {
            if (rg.id === id) {
                match = rg;
                return;
            }
        });
        if (match) {
            this.$store.state.responseGroupCookies.splice(this.$store.state.responseGroupCookies.indexOf(match), 1);
        }
    }

    
    isCurrent(rg) {
        if (this.$store.state.currentResponseGroup && rg) {
            return rg.id === this.$store.state.currentResponseGroup.id;
        }
        return false;
    }

    mounted() {
        api.loadRgs()

        // console.log(this.$store.state.responseGroupCookies.length)
        if (this.$store.state.responseGroupCookies.length > 5) {
            // console.log(this.$store.state.responseGroupCookies[0].uuid)
            api.deleteCookie('rg_' + this.$store.state.responseGroupCookies[0].uuid)
        }
        // this.$store.state.responseGroupCookies.forEach((rg) => {
        //     console.log()
        // });
    }
}
